import {ChangeDetectionStrategy, Component, computed, inject, input, output} from '@angular/core';
import {DesignBlockFileActionButton} from "../../types/design-block-files.types";
import {ModalsService} from "../../../../../../../../core/services/modals.service";
import {DesignBlockData} from "../../../base-design-block-modal/types/base-design-block.types";
import {defaultDesignBlockData} from "../../../base-design-block-modal/configs/default-design-block-data";
import {FilesService} from "../../../../../../../../core/services/files.service";
import {DbFilesStateService} from "../../services/db-files-state.service";
import {LoadingService} from "../../../../../../../../core/services/loading.service";
import {DbShowFileLibraryStateService} from "../../services/db-show-file-library-state.service";
import {MatIconButton} from "@angular/material/button";
import {MatTooltip} from "@angular/material/tooltip";
import {MatIcon} from "@angular/material/icon";

@Component({
  selector: 'div[app-db-header-modal]',
  standalone: true,
  imports: [
    MatIconButton,
    MatTooltip,
    MatIcon
  ],
  templateUrl: './db-header-modal.component.html',
  styleUrl: './db-header-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DbHeaderModalComponent {
  designBlockData = input<DesignBlockData>(defaultDesignBlockData);
  columnKey = input<string>('');
  isActiveUploadFile = input<boolean>(false);
  uploadFiles = output<boolean>();

  private modalService: ModalsService = inject(ModalsService);
  private filesService: FilesService = inject(FilesService);
  private dbFilesStateService: DbFilesStateService = inject(DbFilesStateService);
  private loadingService: LoadingService = inject(LoadingService);
  private dbShowFileLibraryStateService: DbShowFileLibraryStateService = inject(DbShowFileLibraryStateService);

  public isShowFileLibrary = computed(() => this.dbShowFileLibraryStateService.isShowFileLibrary());

  public async handleClick(key: DesignBlockFileActionButton): Promise<void> {
    const actionMap = {
      history: () => this.openHistoryModal(),
      upload: () => this.uploadFiles.emit(!this.isActiveUploadFile()),
      download: () => this.openDownloadModal(),
      showFileLibrary: () => this.handelShowFileLibrary()
    } as const;

    await actionMap[key]?.();
  }

  private async openHistoryModal(): Promise<void> {
    this.modalService.openHistoryChangesModal({
      historyChangesData: this.designBlockData().history,
      columnKey: this.columnKey()
    });
  }

  private async openDownloadModal(): Promise<void> {
    const fileIds = this.dbFilesStateService.dbFileIds();
    this.loadingService.setIsLoadingState(true);
    await this.filesService.downloadArchiveFiles(fileIds)
      .finally(() => this.loadingService.setIsLoadingState(false));
  }

  private handelShowFileLibrary(): void {
    this.dbShowFileLibraryStateService.toggleShowFileLibrary();
  }
}
